import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { AppContext } from "../../../../App";
import { Dialog, DialogContent, DialogTitle, Grid, IconButton } from "@material-ui/core";

import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import SearchIcon from "@material-ui/icons/Search";
import Table from "../../../../components/grade/Table";
import ApiItems from "../../../../api/basics/items/ApiItems";
import TablePagination from "../../../../components/grade/TablePagination";

export default function InputLookupItems({ label, value, onChangeValue, typeItem, required, disabled }) {
    const { showMessageError } = useContext(AppContext);

    const [openModal, setOpenModal] = useState(false);

    const [rowCount, setRowCount] = useState(0);
    const [rowPage, setRowPage] = useState(5);
    const [page, setPage] = useState(0);
    const [dataSourceQuery, setDataSourceQuery] = useState([]);

    const [filterName, setFilterName] = useState("");

    const [open, setOpen] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState("");

    const mayLoadDataSource = useRef(false);

    /*useEffect(() => {
        console.log("Atualizou Datasource");
        
        setDataSource([value]);
    }, [value]);*/

    const loadDataSource = async () => {
        setLoading(true);

        // Condition
        const condition = {};
        if (inputValue) {
            condition["name_like"] = encodeURIComponent(inputValue + "+");
        }
        if (typeItem) {
            condition["type_item"] = typeItem;
        }

        try {
            const result = await ApiItems().query({ page: 1, pageSize: 5, condition });

            if (result.status) {
                if (result.data.length === 1) {
                    setDataSource(result.data);
                    onChangeValue(result.data[0]);
                } else {
                    setDataSource(result.data);
                    setOpen(true);
                }
            } else {
                setDataSource([]);
            }
        } catch (e) {
            showMessageError(e.message);
        } finally {
            setLoading(false);
        }
    };

    const metaData = useMemo(() => [
        {
            label: "Selecionar",
            render: (record) => {
                return (
                    <IconButton
                        size="small"
                        onClick={() => {
                            onChangeValue({ ...record });
                            setOpenModal(false);
                        }}
                    >
                        <ArrowDownwardIcon fontSize="inherit" />
                    </IconButton>
                );
            },
        },
        { label: "Código", field: "id", align: "right" },
        { label: "Nome", field: "name" },
        { label: "Und.Inv.", field: "unit_inventory_id" },
        { label: "Qt.Und.Inv", field: "amount_unit_inventory" },
    ]);

    const loadDataSourceQuery = async (newPage, newRowPage) => {
        // Condition
        const condition = {};
        if (filterName) {
            condition["name_like"] = encodeURIComponent(filterName + "+");
        }
        if (typeItem) {
            condition["type_item"] = typeItem;
        }

        try {
            const result = await ApiItems().query({ page: newPage + 1, pageSize: newRowPage || rowPage, condition });

            if (result.status) {
                setDataSourceQuery(result.data);
                setRowCount(result.info.total);
            } else {
                setDataSource([]);
                if (result.message) {
                    showMessageError(result.message);
                }
            }
        } catch (e) {
            showMessageError(e.message);
        }
    };

    return (
        <>
            <Autocomplete
                autoHighlight
                fullWidth
                disabled={disabled}
                noOptionsText="Digite o nome e pressione 'Enter'"
                forcePopupIcon={false}
                open={open}
                onClose={() => {
                    setOpen(false);
                }}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => {
                    if (!option?.name) {
                        return null;
                    }
                    return `${option.id}-${option.name} (${option.unit_inventory_id}${option.amount_unit_inventory})`;
                }}
                renderOption={(option) => (
                    <>
                        {option.name} <br />
                        {`Código: ${option.id} - Unid.: ${option.unit_inventory_id}${option.amount_unit_inventory}`}
                    </>
                )}
                options={dataSource}
                loading={loading}
                value={value}
                onChange={(event, value, reason) => {
                    onChangeValue(value);
                    if (reason === "select-option") {
                        mayLoadDataSource.current = false;
                    }
                }}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                }}
                filterOptions={(options, state) => {
                    return options;
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        required={required}
                        label={label}
                        fullWidth
                        size="small"
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {loading ? (
                                        <CircularProgress color="inherit" size={20} />
                                    ) : (
                                        <IconButton size="small" onClick={() => setOpenModal(true)} disabled={disabled}>
                                            <SearchIcon fontSize="inherit" />
                                        </IconButton>
                                    )}
                                </>
                            ),
                        }}
                        onKeyDown={(event) => {
                            if (event.keyCode === 13) {
                                if (mayLoadDataSource.current) {
                                    loadDataSource();
                                }
                                mayLoadDataSource.current = false;
                            } else {
                                if (![9, 37, 38, 39, 40].includes(event.keyCode)) {
                                    mayLoadDataSource.current = true;
                                }
                            }
                        }}
                    />
                )}
            />
            <Dialog fullWidth maxWidth={"md"} open={openModal} onClose={() => setOpenModal(false)}>
                <DialogTitle>{label}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                size="small"
                                label="Nome ou código do item"
                                autoFocus
                                fullWidth
                                variant="outlined"
                                value={filterName}
                                onChange={(e) => setFilterName(e.target.value)}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 13 && openModal) {
                                        loadDataSourceQuery(0);
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <IconButton size="small" onClick={() => loadDataSourceQuery(0)}>
                                            <SearchIcon fontSize="inherit" />
                                        </IconButton>
                                    ),
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Table dataSource={dataSourceQuery} metaData={metaData} />
                    <TablePagination
                        rowCount={rowCount}
                        rowPage={rowPage}
                        page={page}
                        onPageChange={(event, newPage) => {
                            loadDataSourceQuery(newPage);
                            setPage(newPage);
                        }}
                        onRowsPerPageChange={(event) => {
                            loadDataSourceQuery(0, event.target.value);
                            setPage(0);
                            setRowPage(event.target.value);
                        }}
                    />
                </DialogContent>
            </Dialog>
        </>
    );
}
